"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Wizard/Message/VariablePopover.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _broadcastTemplateTokens = require('shared/services/broadcastTemplateTokens');
var _format = require('web/screens/Broadcast/format');
var _Form = require('web/components/Form');















const CONTEXT = 28

/* "…your visit with Dr. your care team is on…" */
const readsAs = (template, token, value) => {
  const start = Math.max(0, token.index - CONTEXT)
  const end = token.index + token.text.length
  const isCutBefore = start > 0
  const isCutAfter = end + CONTEXT < template.length
  const before = template.slice(start, token.index)
  const after = template.slice(end, end + CONTEXT)
  return {
    before: isCutBefore ? `…${before.replace(/^\S*\s/, '')}` : before,
    after: isCutAfter ? `${after.replace(/\s\S*$/, '')}…` : after,
    value,
  }
}

/* F3: type a default for the clicked variable instead of writing
 * {{name | default}} by hand. The title and the label above the input make
 * clear the default is the text typed here, not the variable's name. */
const VariablePopover = ({
  token, template, uses, coverage, position, onApply, exceedsLimit, limit, onClose,
}) => {
  const [value, setValue] = _react.useState.call(void 0, _nullishCoalesce(token.fallback, () => ( '')))
  const [applyToAll, setApplyToAll] = _react.useState.call(void 0, false)
  const ref = _react.useRef(null)
  const inputId = _react.useId.call(void 0, )
  const label = _optionalChain([coverage, 'optionalAccess', _ => _.Source]) || token.name
  const missing = coverage ? coverage.total - coverage.have : null
  const hasBraces = _broadcastTemplateTokens.INVALID_DEFAULT.test(value)
  const isTooLong = !hasBraces && exceedsLimit(value, applyToAll)
  const isInvalid = hasBraces || isTooLong
  const reads = readsAs(template, token, value.trim())

  _react.useEffect.call(void 0, 
    () => {
      const onKey = (e) => { if (e.key === 'Escape') onClose() }
      const onDown = (e) => {
        if (ref.current && !ref.current.contains(e.target )) onClose()
      }
      document.addEventListener('keydown', onKey)
      document.addEventListener('mousedown', onDown)
      return () => {
        document.removeEventListener('keydown', onKey)
        document.removeEventListener('mousedown', onDown)
      }
    },
    [onClose],
  )

  const submit = () => { if (!isInvalid) onApply(value, applyToAll) }

  return (
    _react2.default.createElement('div', {
      ref: ref,
      role: "dialog",
      'aria-label': `Default for {{${token.name}}}`,
      className: "broadcast-popover",
      style: position, __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}

      , _react2.default.createElement('div', { className: "broadcast-popover--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}}, "Default for "
          , _react2.default.createElement('code', { className: "broadcast-popover--token", __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}}, `{{${token.name}}}`)
      )
      , _react2.default.createElement('p', { className: "broadcast-popover--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}, "Used when a recipient has no "
              ,  label , " value."
        ,  missing !== null && coverage && (
          _react2.default.createElement(_react2.default.Fragment, null, " " , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 88}},  _format.formatCount.call(void 0, missing) , " of "  ,  _format.formatCount.call(void 0, coverage.total) ), " have none."  )
        )
      )
      , _react2.default.createElement('label', { htmlFor: inputId, className: "broadcast-popover--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}, "If " ,  label , " is blank, use:"   )
      , _react2.default.createElement('input', {
        id: inputId,
        autoFocus: true,
        className: "blm-text-input broadcast-popover--input" ,
        value: value,
        placeholder: "e.g. your care team"   ,
        onChange: e => setValue(e.target.value),
        onKeyDown: e => { if (e.key === 'Enter') { e.preventDefault(); submit() } }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 92}}
      )
      ,  hasBraces && (
        _react2.default.createElement('p', { role: "alert", className: "broadcast-popover--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}, "A default can't contain "    , '{', " or "  , '}', ".")
      )
      ,  isTooLong && (
        _react2.default.createElement('p', { role: "alert", className: "broadcast-popover--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}}, "That makes the message longer than "
                ,  _format.formatCount.call(void 0, limit) , " characters."
        )
      )
      ,  reads.value && !isInvalid && (
        _react2.default.createElement('p', { className: "broadcast-popover--reads", __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}}, "Reads: “"
           ,  reads.before , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 111}},  reads.value ),  reads.after , "”"
        )
      )
      ,  uses > 1 && (
        _react2.default.createElement('label', { className: "broadcast-popover--all", __self: this, __source: {fileName: _jsxFileName, lineNumber: 115}}
          , _react2.default.createElement('input', { type: "checkbox", checked: applyToAll, onChange: e => setApplyToAll(e.target.checked), __self: this, __source: {fileName: _jsxFileName, lineNumber: 116}} ), "Use it for all "
              ,  uses , " uses of "   , `{{${token.name}}}`
        )
      )
      , _react2.default.createElement('div', { className: "broadcast-popover--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 120}}
        ,  token.fallback !== null && (
          _react2.default.createElement('button', { type: "button", className: "broadcast-popover--remove", onClick: () => onApply('', applyToAll), __self: this, __source: {fileName: _jsxFileName, lineNumber: 122}}, "Remove default"

          )
        )
        , _react2.default.createElement(_Form.Button, { onClick: submit, isDisabled: isInvalid, __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}, "Apply")
      )
    )
  )
}

exports. default = VariablePopover
